const whatsappMessage = "Hi dYzital, I want help growing my business online.";

export const whatsappUrl = `https://wa.me/916281506590?text=${encodeURIComponent(
  whatsappMessage
)}`;

export const proofClients = [
  {
    name: "Sai Hasini Dental Clinic",
    logo: "/client-logos/shdc.png",
    industry: "Healthcare",
  },
  {
    name: "Prime Hospitals",
    logo: "/client-logos/prime-hospitals.png",
    industry: "Healthcare",
  },
  {
    name: "Manasa Veg & Non Veg",
    logo: "/client-logos/manasa.png",
    industry: "Restaurant",
  },
  {
    name: "Vakulaa Tiffins",
    logo: "/client-logos/vakulaa-tiffins.png",
    industry: "Food brand",
  },
];

export const servicesData = [
  {
    slug: "seo",
    icon: "SEO",
    title: "Search Engine Growth",
    shortTitle: "SEO",
    routeTitle: "SEO Services for Growing Businesses in Hyderabad",
    metaTitle: "SEO Services in Hyderabad for Better Organic Leads | dYzital",
    metaDescription:
      "dYzital provides SEO services in Hyderabad including technical SEO, local SEO, content optimization, and search visibility improvements for growing businesses.",
    desc: "Technical audits, on-page strategy, and authority building that increase qualified organic traffic.",
    outcome: "Outcome: sustainable inbound demand and stronger ranking stability.",
    detail:
      "We build a compounding search engine strategy around your highest-intent pages, technical SEO issues, and authority opportunities so rankings turn into real pipeline.",
    summary:
      "Our SEO services help businesses improve search visibility, attract qualified visitors, and build pages that answer high-intent customer searches. We focus on technical fixes, local SEO, content depth, on-page optimization, and practical reporting.",
    bullets: [
      "Technical SEO audits",
      "Content clusters + on-page optimization",
      "Authority and local visibility growth",
    ],
    benefits: [
      "Improve rankings for service and location searches",
      "Build stronger pages for high-intent keywords",
      "Fix crawlability, metadata, and technical SEO gaps",
      "Track organic enquiries with clearer reporting",
    ],
    process: [
      "Audit technical, local, and content gaps",
      "Prioritize service pages and keyword clusters",
      "Optimize pages, schema, internal links, and reporting",
    ],
    faqs: [
      {
        question: "What does dYzital include in SEO services?",
        answer:
          "dYzital includes technical SEO audits, on-page optimization, local SEO, content planning, internal linking, and reporting focused on qualified organic leads.",
      },
      {
        question: "Can SEO help local Hyderabad businesses?",
        answer:
          "Yes. Local SEO helps Hyderabad businesses improve visibility for nearby customers searching for services, clinics, restaurants, and local providers.",
      },
      {
        question: "How long does SEO usually take?",
        answer:
          "Most businesses should expect early technical improvements quickly, with meaningful ranking and lead growth usually building over several months.",
      },
    ],
    visualLabel: "Organic Visibility",
    visualType: "bars",
    visualPoints: ["42%", "68%", "91%"],
  },
  {
    slug: "ppc",
    icon: "ADS",
    title: "Paid Media Performance",
    shortTitle: "PPC",
    routeTitle: "PPC and Google Ads Management for Better Lead Quality",
    metaTitle: "PPC & Google Ads Management for Lead Generation | dYzital",
    metaDescription:
      "Run better Google and Meta ad campaigns with dYzital. We manage PPC strategy, campaign structure, creative testing, landing pages, and lead quality optimization.",
    desc: "Google and Meta campaigns tuned with creative testing, audience segmentation, and budget control.",
    outcome: "Outcome: lower CPA and higher intent conversions.",
    detail:
      "Campaigns are structured around clear funnel stages, conversion events, and creative testing loops so spend flows toward the audiences and messages that actually convert.",
    summary:
      "Our paid media service helps businesses run Google Ads and Meta campaigns with clearer targeting, stronger creatives, better landing page flow, and practical budget control. The focus is lead quality, not just clicks.",
    bullets: [
      "Channel-specific campaign architecture",
      "Creative + audience testing",
      "Bid, budget, and CPA optimization",
    ],
    benefits: [
      "Launch campaigns with cleaner account structure",
      "Reduce wasted spend through intent-led targeting",
      "Improve landing page and form conversion flow",
      "Measure enquiries, calls, and campaign performance",
    ],
    process: [
      "Review offer, audience, and conversion goals",
      "Build campaigns by funnel stage and intent",
      "Test creatives, keywords, audiences, and landing pages",
    ],
    faqs: [
      {
        question: "Which ad platforms does dYzital manage?",
        answer:
          "dYzital supports Google Ads, Meta ads, and performance campaigns where the goal is measurable enquiries, calls, or sales opportunities.",
      },
      {
        question: "Do you help with landing pages for PPC?",
        answer:
          "Yes. PPC performance often depends on landing page clarity, speed, trust signals, and form flow, so landing page improvements are part of the strategy.",
      },
      {
        question: "How do you optimize paid ads?",
        answer:
          "We optimize campaign structure, targeting, creative, budgets, bids, landing pages, and conversion tracking around lead quality and cost per acquisition.",
      },
    ],
    visualLabel: "Campaign Efficiency",
    visualType: "line",
    visualPoints: ["Week 1", "Week 4", "Week 8"],
  },
  {
    slug: "web-development",
    icon: "WEB",
    title: "Web Experience Design",
    shortTitle: "Web Development",
    routeTitle: "Website Development for Conversion-Focused Business Growth",
    metaTitle: "Website Development for SEO and Lead Generation | dYzital",
    metaDescription:
      "dYzital builds responsive, SEO-ready websites and landing pages focused on clarity, speed, trust, and lead generation for growing businesses.",
    desc: "Fast, responsive, SEO-ready websites built around conversion pathways and business goals.",
    outcome: "Outcome: better engagement and lead quality.",
    detail:
      "We design conversion-focused websites with stronger page flow, content hierarchy, and mobile usability so more visitors understand your offer and take action.",
    summary:
      "Our website development work focuses on business clarity, mobile usability, SEO foundations, page speed, and conversion paths. We build websites and landing pages that explain your offer and guide visitors toward enquiries.",
    bullets: [
      "Responsive UX and messaging structure",
      "Conversion-focused landing pages",
      "Performance and SEO readiness",
    ],
    benefits: [
      "Create pages that clearly explain services and outcomes",
      "Improve mobile experience and form usability",
      "Build SEO-ready structure and metadata",
      "Turn traffic into enquiries with stronger CTAs",
    ],
    process: [
      "Map audience, offer, and page goals",
      "Design content hierarchy and conversion flow",
      "Build responsive pages with SEO and performance basics",
    ],
    faqs: [
      {
        question: "Does dYzital build SEO-friendly websites?",
        answer:
          "Yes. Website projects include SEO-ready structure, responsive layouts, metadata, internal links, and content hierarchy for better crawlability.",
      },
      {
        question: "Can you improve an existing website?",
        answer:
          "Yes. We can improve existing websites by refining messaging, page flow, mobile experience, forms, speed, and conversion sections.",
      },
      {
        question: "What type of websites do you build?",
        answer:
          "We build business websites, service landing pages, lead generation pages, and conversion-focused web experiences for growing companies.",
      },
    ],
    visualLabel: "Conversion Journey",
    visualType: "steps",
    visualPoints: ["Visit", "Consider", "Convert"],
  },
  {
    slug: "ai-automation",
    icon: "AI",
    title: "AI Automation Systems",
    shortTitle: "AI Automation",
    routeTitle: "AI Automation for Faster Follow-Up and Business Workflows",
    metaTitle: "AI Automation Services for Business Growth | dYzital",
    metaDescription:
      "Use AI automation to improve lead follow-up, customer workflows, reporting, and repeatable business processes with dYzital.",
    desc: "AI-assisted workflows that reduce manual work and improve speed from enquiry to follow-up.",
    outcome: "Outcome: faster response times and cleaner operations.",
    detail:
      "We identify repeated sales, marketing, and follow-up tasks that can be supported with automation so teams respond faster, track better, and avoid missed opportunities.",
    summary:
      "Our AI automation service helps businesses reduce repetitive manual work across lead capture, follow-up, reporting, and customer communication. We focus on practical workflows that support sales and marketing outcomes.",
    bullets: [
      "Lead follow-up workflow mapping",
      "AI-assisted response and routing systems",
      "Reporting and task automation",
    ],
    benefits: [
      "Respond to enquiries faster",
      "Reduce missed follow-ups and manual tracking",
      "Create repeatable sales and marketing workflows",
      "Connect forms, CRM, and communication channels",
    ],
    process: [
      "Identify repeated tasks and handoff gaps",
      "Design practical automation workflows",
      "Test, document, and refine the system with your team",
    ],
    faqs: [
      {
        question: "What can AI automation help with?",
        answer:
          "AI automation can help with lead follow-up, enquiry routing, CRM updates, reporting, content workflows, and repeated operational tasks.",
      },
      {
        question: "Is AI automation only for large companies?",
        answer:
          "No. Small and growing businesses can benefit from simple automations that save time and improve response consistency.",
      },
      {
        question: "Does dYzital connect automation with marketing?",
        answer:
          "Yes. We focus on automation that supports marketing, sales follow-up, CRM movement, and clearer reporting.",
      },
    ],
    visualLabel: "Automation Flow",
    visualType: "network",
    visualPoints: ["Lead", "AI Assist", "Follow-up"],
  },
  {
    slug: "crm-marketing",
    icon: "CRM",
    title: "CRM Marketing Automation",
    shortTitle: "CRM Marketing",
    routeTitle: "CRM Marketing Automation for Better Lead Follow-Up",
    metaTitle: "CRM Marketing Automation and Lead Nurture | dYzital",
    metaDescription:
      "dYzital helps businesses improve lead capture, CRM workflows, nurture sequences, lead scoring, and automated follow-up systems.",
    desc: "Lifecycle journeys, lead scoring, and nurture flows to improve close rates without manual follow-up.",
    outcome: "Outcome: predictable pipeline movement.",
    detail:
      "We connect lead capture, follow-up logic, and lifecycle messaging so prospects receive relevant communication automatically instead of slipping through the cracks.",
    summary:
      "Our CRM marketing service connects forms, lead sources, follow-up workflows, lifecycle messaging, and reporting. The goal is to keep prospects moving after they enquire instead of losing them in manual handoffs.",
    bullets: [
      "Lead capture and routing logic",
      "Lifecycle nurture sequences",
      "Scoring, tagging, and follow-up automation",
    ],
    benefits: [
      "Improve speed-to-lead and follow-up consistency",
      "Segment prospects by source, stage, and interest",
      "Automate nurture messages and sales reminders",
      "Make pipeline reporting easier to understand",
    ],
    process: [
      "Audit lead sources and current CRM flow",
      "Define lifecycle stages and follow-up rules",
      "Build automation, nurture, and reporting workflows",
    ],
    faqs: [
      {
        question: "What CRM marketing systems does dYzital support?",
        answer:
          "dYzital can support CRM workflows around lead capture, routing, tagging, nurture sequences, follow-up reminders, and marketing reporting.",
      },
      {
        question: "Why is CRM automation important?",
        answer:
          "CRM automation helps businesses respond faster, avoid lost leads, and keep prospects moving through the sales process.",
      },
      {
        question: "Can CRM marketing work with paid ads?",
        answer:
          "Yes. CRM workflows can connect paid ad leads with follow-up sequences, sales tasks, and performance reporting.",
      },
    ],
    visualLabel: "Automation Flow",
    visualType: "network",
    visualPoints: ["Lead", "Nurture", "Close"],
  },
  {
    slug: "social-media-marketing",
    icon: "SOC",
    title: "Social Content Systems",
    shortTitle: "Social Media",
    routeTitle: "Social Media Marketing for Awareness, Trust, and Enquiries",
    metaTitle: "Social Media Marketing Services for Businesses | dYzital",
    metaDescription:
      "Build stronger social media presence with dYzital through content calendars, campaign ideas, platform-native creative, and enquiry-focused workflows.",
    desc: "Platform-native campaigns and content calendars that turn passive viewers into active prospects.",
    outcome: "Outcome: stronger awareness and faster trust building.",
    detail:
      "We turn scattered posting into a repeatable content engine with brand-safe creative direction, publishing rhythm, and hooks designed to increase saves, shares, and enquiries.",
    summary:
      "Our social media marketing service helps businesses show up consistently with content that builds trust, supports campaigns, and creates more enquiry opportunities. We focus on repeatable systems, not random posting.",
    bullets: [
      "Platform-native content calendars",
      "Campaign concepts and hook libraries",
      "Engagement and response workflows",
    ],
    benefits: [
      "Create a consistent content rhythm",
      "Build trust before prospects enquire",
      "Support campaigns with stronger creative ideas",
      "Connect engagement with response and lead workflows",
    ],
    process: [
      "Define audience, brand voice, and content pillars",
      "Plan campaign calendars and creative hooks",
      "Review performance and refine content direction",
    ],
    faqs: [
      {
        question: "What does social media marketing include?",
        answer:
          "It includes content planning, campaign ideas, creative direction, posting rhythm, engagement workflows, and performance review.",
      },
      {
        question: "Can social media generate leads?",
        answer:
          "Yes, when content builds trust and connects to clear enquiry paths, social media can support lead generation and sales conversations.",
      },
      {
        question: "Which industries can use social media marketing?",
        answer:
          "Clinics, hospitals, restaurants, local businesses, real estate teams, and growing brands can use social media to build visibility and trust.",
      },
    ],
    visualLabel: "Audience Engagement",
    visualType: "pulse",
    visualPoints: ["Reach", "Shares", "DMs"],
  },
];

export const getServiceBySlug = (slug) =>
  servicesData.find((service) => service.slug === slug);

export const routeAliases = {
  "/seo-services-hyderabad": "seo",
  "/google-ads-services": "ppc",
  "/website-development-company": "web-development",
  "/ai-automation-services": "ai-automation",
  "/social-media-marketing": "social-media-marketing",
  "/digital-marketing-agency-hyderabad": "seo",
  "/seo-company-vijayawada": "seo",
};

export const getServiceSlugByPath = (pathname) => {
  const serviceMatch = pathname.match(/^\/services\/([^/]+)$/);
  return serviceMatch ? serviceMatch[1] : routeAliases[pathname];
};
